import React from 'react';
import * as venn from 'venn.js';
import * as d3 from "d3";
import { connect } from 'react-redux';
import { Spin, Table } from 'antd';
import { Row, Col } from 'antd';
import _ from 'lodash';
import { getProxyRepeatInfo } from './reducers';
const { Column } = Table;
const handleData = obj => {
    let {list: data, map} = obj;
    let dataNew = JSON.stringify(map);
    dataNew = JSON.parse(dataNew);
    dataNew = _.chain(dataNew)
        .map((item, key) => {
            let { ipDistinctCount } = item;
            return {sets: [key], size: ipDistinctCount};
        })
        .flattenDeep()
        .value();
    let dataR = JSON.stringify(data);
    dataR = JSON.parse(dataR);
    dataR = _.chain(dataR)
        .filter(_d => _d.key !== '汇总')
        .map(item => {
            let {repeatCount, key} = item;
            let keyArr = key.split(' ');
            return {sets: [...keyArr], size: repeatCount};
        })
        .value();
    let setNew = [...dataNew, ...dataR];
    return setNew;
}
class VennChart extends React.Component {
    componentDidMount() {
        this.props.getProxyRepeatInfo().then(obj => {
            let setNew = handleData(obj);
            // console.log('dataNew====', setNew)
            let chart = venn.VennDiagram().fontSize('16px').width(500).height(500);
            let div = d3.select('#venn');
            div.datum(setNew).call(chart);
            // add a tooltip
            let tooltip = d3.select('body').append('div').attr('class', 'venntooltip');

            div.selectAll('path')
                .style('stroke-opacity', 0)
                .style('stroke', '#fff')
                .style('stroke-width', 3);

            // add listeners to all the groups to display tooltip on mouseover
            div.selectAll('g')
                .on('mouseover', function(d, i) {
                    // sort all the areas relative to the current item
                    venn.sortAreas(div, d);

                    // Display a tooltip with the current size
                    tooltip.transition().duration(400).style('opacity', .9);
                    tooltip.text(d.size + ' ' + d.sets.join('&'));

                    // highlight the current path
                    let selection = d3.select(this).transition('tooltip').duration(400);
                    selection.select('path')
                        .style('fill-opacity', d.sets.length == 1 ? .4 : .1)
                        .style('stroke-opacity', 1);
                })
                .on('mousemove', function() {
                    tooltip.style('left', (d3.event.pageX) + 'px')
                        .style('top', (d3.event.pageY - 28) + 'px');
                })
                .on('mouseout', function(d, i) {
                    console.log('out')
                    tooltip.transition().duration(400).style('opacity', 0);
                    let selection = d3.select(this).transition('tooltip').duration(400);
                    selection.select('path')
                        .style('fill-opacity', d.sets.length == 1 ? .25 : .0)
                        .style('stroke-opacity', 0);
                });
        });
    }
    componentWillReceiveProps(nextProps) {
        // console.log(nextProps, '====')
        // let setNew = handleData(nextProps.proxyrepeatinfo);
        // console.log('componentWillReceiveProps====', setNew)
        // let chart = venn.VennDiagram().fontSize('10px').width(500).height(500);
        // let div = d3.select('#venn');
        // div.datum(setNew).call(chart);
    }
    render() {
        const { isShowEchart, proxyrepeatinfo } = this.props;
        let { list, map } = proxyrepeatinfo;
        let temp;
        if (list.length) {
            console.log(map);
            temp = JSON.stringify(map);
            temp = JSON.parse(temp);
            temp = _.chain(temp)
                .map((item, key) => {
                    let { ipDistinctCount: repeatCount } = item;
                    return {repeatCount, key};
                })
                .value();
        }
        return (
            <Spin spinning={isShowEchart} tip="加载中...">
                <Row gutter={2}>
                    <Col span={6} style={{width: '500px'}}>
                        <div id="venn" style={{width: '800px'}}></div>
                    </Col>
                    <Col span={8}>
                        <Table dataSource={temp} pagination={false} bordered>
                            <Column title="代理商" dataIndex="key" key="key" />
                            <Column title="IP总数" dataIndex="repeatCount" key="repeatCount" />
                        </Table>
                    </Col>
                    <Col span={8}>
                        <Table dataSource={list} pagination={false} bordered>
                            <Column title="代理商" dataIndex="key" key="key" />
                            <Column title="交叉数" dataIndex="repeatCount" key="repeatCount" />
                        </Table>
                    </Col>
                </Row>

            </Spin>
        );
    }
}

const mapStateToProps = state => ({
    isShowEchart: state.agencyAnalysis.uiStatus.isRepeatLoading,
    proxyrepeatinfo: state.agencyAnalysis.proxyrepeatinfo,
});
const mapDispatchToProps = dispatch => ({
    getProxyRepeatInfo: () => dispatch(getProxyRepeatInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VennChart);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/agencyAnalysis/venn.js